module.exports = __webpack_public_path__ + "static/img/yamamoto_07.00eacdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yamamoto_07.jpg
// module id = LDqm
// module chunks = 0